import {
  CUSTOMERS,
  CUSTOMER_DETAIL,
  REDEMPTION_HISTORIES,
  POINT_ACTIVITIES,
  CUSTOMERS_DOWNLOAD_TEMPLATE,
  CUSTOMERS_EXPORT,
  CUSTOMERS_SUBMIT_FEEDBACK
} from './constants'

/**
 * @see https://github.com/mokapos/moka-rails/blob/master/app/controllers/api/v2/customers_controller.rb#L5
 * @param params
 * @return {Axios.IPromise<U>}
 */
export function getCustomers (params) {
  return axios.get(CUSTOMERS, {params, withCredentials: false})
    .then((response) => {
      return Promise.resolve(response)
    })
    .catch((error) => {
      if (error.response) {
        let eobj
        let {data} = error.response
        if (data.errors) {
          eobj = new Error(data.errors)
        } else if (data.message) {
          eobj = new Error(data.message)
        } else {
          eobj = new Error(error.message)
        }
        return Promise.reject(eobj)
      } else {
        return Promise.reject(new Error(error.message))
      }
    })
}

/**
 * @see https://github.com/mokapos/moka-rails/blob/master/app/controllers/api/v2/customers_controller.rb#L35
 * @param params
 * @return {Axios.IPromise<U>}
 */
export function getCustomerDetail (customerId, params) {
  return axios
    .get(CUSTOMER_DETAIL(customerId), {params})
    .then((response) => {
      return Promise.resolve(response)
    })
    .catch((error) => {
      if (error.response) {
        let eobj
        let {data} = error.response
        if (data.errors) {
          eobj = new Error(data.errors)
        } else if (data.message) {
          eobj = new Error(data.message)
        } else {
          eobj = new Error(error.message)
        }
        return Promise.reject(eobj)
      } else {
        return Promise.reject(new Error(error.message))
      }
    })
}

export function getRedemptionHistories (customerId, params) {
  return axios
    .get(REDEMPTION_HISTORIES(customerId), {params})
    .then((response) => {
      return Promise.resolve(response)
    })
    .catch((error) => {
      if (error.response) {
        let eobj
        let {data} = error.response
        if (data.errors) {
          eobj = new Error(data.errors)
        } else if (data.message) {
          eobj = new Error(data.message)
        } else {
          eobj = new Error(error.message)
        }
        return Promise.reject(eobj)
      } else {
        return Promise.reject(new Error(error.message))
      }
    })
}

export function getPointActivities (customerId, params) {
  return axios
    .get(POINT_ACTIVITIES(customerId), {params})
    .then((response) => {
      return Promise.resolve(response)
    })
    .catch((error) => {
      if (error.response) {
        let eobj
        let {data} = error.response
        if (data.errors) {
          eobj = new Error(data.errors)
        } else if (data.message) {
          eobj = new Error(data.message)
        } else {
          eobj = new Error(error.message)
        }
        return Promise.reject(eobj)
      } else {
        return Promise.reject(new Error(error.message))
      }
    })
}

/**
 * @see https://github.com/mokapos/moka-rails/blob/master/app/controllers/api/v2/customers_controller.rb
 * @param none
 * @return {Axios.IPromise<U>}
 */
export function getCustomerTemplate () {
  return axios.get(CUSTOMERS_DOWNLOAD_TEMPLATE, {withCredentials: true})
    .then((response) => {
      return Promise.resolve(response)
    })
    .catch((error) => {
      return Promise.reject(new Error(error.message))
    })
}

export function getCustomerExport (params) {
  return axios.get(CUSTOMERS_EXPORT, {params})
    .then((response) => {
      return Promise.resolve(response)
    })
    .catch((error) => {
      return Promise.reject(new Error(error.message))
    })
}

export function postCustomerFeedback (data) {
  return axios.post(CUSTOMERS_SUBMIT_FEEDBACK, data, {withCredentials: true})
    .then((response) => {
      return Promise.resolve(response)
    })
    .catch((error) => {
      return Promise.reject(new Error(error.message))
    })
}



// WEBPACK FOOTER //
// ./app/api/customers/customers.js